"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShortcuts = exports.ShortcutsProvider = void 0;
var react_1 = __importStar(require("react"));
var shortcuts_json_1 = __importDefault(require("./shortcuts.json"));
var SHORTCUTS = shortcuts_json_1.default.map(function (_a) {
    var shortcuts = _a.shortcuts;
    return shortcuts;
}).flat();
var ShortcutsContext = (0, react_1.createContext)({});
var ShortcutsProvider = function (_a) {
    var children = _a.children, onShortcut = _a.onShortcut;
    var onKeyDown = (0, react_1.useCallback)(function (_a) {
        var ctrlKey = _a.ctrlKey, shiftKey = _a.shiftKey, key = _a.key;
        SHORTCUTS.forEach(function (_a) {
            var name = _a.name, combos = _a.combos;
            return combos.forEach(function (keys) {
                var modifers = (keys.includes('Ctrl') ? ctrlKey : true)
                    && (keys.includes('Shift') ? shiftKey : true);
                if (modifers && keys.includes(key.toUpperCase())) {
                    onShortcut(name);
                }
            });
        });
    }, [onShortcut]);
    (0, react_1.useEffect)(function () {
        document.addEventListener('keydown', onKeyDown);
        return function () {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [onKeyDown]);
    return (react_1.default.createElement(ShortcutsContext.Provider, { value: { grouped: shortcuts_json_1.default } }, children));
};
exports.ShortcutsProvider = ShortcutsProvider;
var useShortcuts = function () {
    return (0, react_1.useContext)(ShortcutsContext);
};
exports.useShortcuts = useShortcuts;
